import {Component, input, ChangeDetectionStrategy, computed} from "@angular/core"
import {fundamentalTypes, getInterfaceIdPrefix, InterfaceDescriptor, TemplateInstance, isAnyJsonValue} from "@cm/template-nodes"
import {TemplateNodeComponent} from "@app/template-editor/components/template-node/template-node.component"

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: "cm-template-instance-output",
    templateUrl: "./template-instance-output.component.html",
    styleUrl: "./template-instance-output.component.scss",
    imports: [TemplateNodeComponent],
})
export class TemplateInstanceOutputComponent {
    readonly $templateInstance = input.required<TemplateInstance>({alias: "templateInstance"})
    readonly $descriptor = input.required<InterfaceDescriptor<unknown>>({alias: "descriptor"})

    readonly $output = computed(() => {
        const descriptor = this.$descriptor()
        const template = this.$templateInstance()

        const [, key] = getInterfaceIdPrefix(descriptor.props.id)

        const fundamentalType = Object.values(fundamentalTypes).find((ft) => descriptor instanceof ft.InfoClass)
        if (!fundamentalType) throw new Error("Invalid descriptor type")
        return new fundamentalType.Output({parameters: {template, outputId: key, name: descriptor.props.name}})
    })

    readonly $tooltip = computed(() => {
        const descriptor = this.$descriptor()
        return isAnyJsonValue(descriptor.props.value) ? JSON.stringify(descriptor.props.value) : undefined
    })
}
